<template>
  <div class="account-troubleshooting">
    <!-- TODO uncomment when needed or remove if it is not-->
    <!-- <account-troubleshooting-faq :faq="faq"></account-troubleshooting-faq>
    <account-troubleshooting-solutions></account-troubleshooting-solutions>     -->
    <account-troubleshooting-history      
      :history="history"
      :params="tableParams"
      :loading="loading"
      @trouble="onTrouble"
      @sort="onSort"
      @page="onPaginate"      
    ></account-troubleshooting-history>
    <account-troubleshooting-reasons-modal
      :open="reasonsModalOpen && !!selectedReport"
      :report="selectedReport"      
      :timezone="timezone"
      :account-troubleshooting-reasons="accountTroubleshootingReasons"
      @close="reasonsModalOpen = false"
      @contact="onContact"
    />    
  </div>
</template>

<script>
import AccountTroubleshootingHistory from '../components/account/troubleshooting/AccountTroubleshootingHistory.vue';
import AccountTroubleshootingReasonsModal from '../components/account/troubleshooting/AccountTroubleshootingReasonsModal.vue';
import {accountTroubleshootingReasons} from '../components/account/troubleshooting/AccountTroubleshootingReasons';
import {launchHubspotWidget} from '../utility/launchHubspotWidget.js'
import * as Sentry from "@sentry/vue";

export default {
  name: 'account-troubleshooting',
  components: {    
    AccountTroubleshootingHistory,
    AccountTroubleshootingReasonsModal,
  },
  data() {
    return {
      accountTroubleshootingReasons: accountTroubleshootingReasons,
      history: [],
      selectedReport: null,
      reasonsModalOpen: false,
      tableParams: {
        page: 1,
        limit: 5,
        sort: 'desc',
        total: 0
      },
      loading: false,
    };
  },
  props: {
    timezone: {
      type: String,
      required: true,
    },
  },
  methods: {
    onSort(sort) {
      this.tableParams.sort = sort;
    },
    onPaginate(page) {
      this.tableParams.page = page;
    },
    // onChangeLimit(limit) {
    //   this.tableParams.limit = limit;
    // },
    onTrouble(report) {
      this.selectedReport = report;      
      this.$nextTick(() => (this.reasonsModalOpen = true));
    }, 
    handleError(error) {      
      $.notify('Something went wrong', "error");
      Sentry.captureException(error);
    },
    onContact() {
      launchHubspotWidget();
      this.reasonsModalOpen = false;
    },
  },
  watch: {
    tableParams: {
      immediate: true,
      deep: true,
      async handler(params) {
        this.loading = true;        
        try {
          const endPoint = `/api/?entity=vessel&action=troubleshooting&page=${params.page}&limit=${params.limit}&sort=${params.sort}`;
          const response = await axios.get(endPoint);
          this.history = response.data?.data || []; 
          params.total = response.data.meta?.total_count || 0;
        } catch (error) {
          this.handleError(error);
        } finally {
          this.loading = false;
        }
      },
    },
  },
};

</script>

<style lang="scss" scoped>
.account-troubleshooting {
  text-align: left;
}
</style>
